import React, { useEffect, useState } from 'react'

interface Props {
  src?: string
  className?: string
  alt?: string
  fallback?: string | JSX.Element
}

const ImageFallback = ({
  className = '',
  src = '/',
  alt = 'image',
  fallback
}: Props): JSX.Element => {
  const [imgError, setImgError] = useState(false)
  const [imgSrc, setImgSrc] = useState(src)

  useEffect(() => {
    if (imgError && typeof fallback === 'string') {
      setImgSrc(fallback as string)
    }

    if (imgError && typeof fallback !== 'string') {
      setImgSrc('')
    }
  }, [imgError])

  useEffect(() => {
    setImgSrc(src)
  }, [src])

  return (
    <>
      {imgSrc ? (
        <img
          className={className}
          src={imgSrc}
          alt={alt}
          onError={() => setImgError(true)}
        />
      ) : (
        fallback
      )}
    </>
  )
}

export default ImageFallback
